import styles from './PlacingOrderNotice.module.scss';
import cn from 'classnames';
import { IPlacingOrderNoticeProps } from '../../types';
import { Text, TextSize } from '@components/Text';

const PlacingOrderNotice: React.FC<IPlacingOrderNoticeProps> = (props: IPlacingOrderNoticeProps): React.ReactElement => {
  const { description, title } = props;

  return (
      <div className={cn(styles.notice, styles.noticeRed)}>
        <Text size={TextSize.M}>
          <b className={cn(styles.text, styles.textRed)}>
            {title}
          </b>
        </Text>
        {description && (
            <Text size={TextSize.M}>
              <span className={cn(styles.text, styles.textRed)}>
                {description}
              </span>
            </Text>
        )}
      </div>
  );
};

export default PlacingOrderNotice;